import {HojasCallCenterComponent} from "../hojas-call-center.component";
import {BusArtCallcenter} from "../models/BusArtCallcenter";
import {ArticuloContact} from "../models/ArticuloContact";
import {PrimaComponent} from "../prima/prima.component";

export class PilotosFunctions{
  static comboQuien1(formularioHojas: HojasCallCenterComponent){
    formularioHojas.llamada.recomendado = "A";
  }
  static comboQuien2(formularioHojas: HojasCallCenterComponent){
    formularioHojas.llamada.recomendado = "B";
  }
  static comboQuien3(formularioHojas: HojasCallCenterComponent){
    formularioHojas.llamada.recomendado = "C";
  }
  static comboQuien4(formularioHojas: HojasCallCenterComponent){
    formularioHojas.llamada.recomendado = "D";
  }
  static comboQuien7(formularioHojas: HojasCallCenterComponent){
    formularioHojas.llamada.recomendado = "G";
  }
  static textoSiniestro(formularioHojas: HojasCallCenterComponent){
    formularioHojas.asegurado.siniestro = "";
    formularioHojas.enabledSin = true;
  }
  static caseAsefa(formularioHojas: HojasCallCenterComponent){
    formularioHojas.tipoTaller = "";
    formularioHojas.showObtenerSiniestro = true;
    this.comboQuien2(formularioHojas);
  }
  static caseMapfre(formularioHojas: HojasCallCenterComponent){
    this.comboQuien2(formularioHojas);
    formularioHojas.tipoTaller = "mapfre";
  }
  static caseRepa(formularioHojas: HojasCallCenterComponent){
    formularioHojas.tipoTaller = "";
    this.comboQuien7(formularioHojas);
    formularioHojas.llamada.tipo = "18";
    formularioHojas.llamada.origen = "01";
    formularioHojas.busquedaArticulos = false;
    formularioHojas.vehiculo.descSiniestro = "PROMOCION";
  }
  static caseGeneraliRepa(formularioHojas: HojasCallCenterComponent){

    this.comboQuien2(formularioHojas);
    this.ponerCia(formularioHojas, "GENERALI ESP. SEGUROS Y REASEGUROS");
  }
  static caseAxa(formularioHojas: HojasCallCenterComponent){
    formularioHojas.tipoTaller = "";
    this.comboQuien2(formularioHojas);
    formularioHojas.llamada.origen = "02";
    this.ponerCia(formularioHojas, "AXA SEGUROS GENERALES S.A.");
    formularioHojas.showAxa = true;
  }
  static caseNorthgate(formularioHojas: HojasCallCenterComponent){
    formularioHojas.tipoTaller = "";
    formularioHojas.mostrarDialogoAxa();
    this.comboQuien2(formularioHojas);
    formularioHojas.asegurado.siniestro = "VERIFICADO";
  }
  static caseAbanca(formularioHojas: HojasCallCenterComponent){
    formularioHojas.tipoTaller = "";
    this.comboQuien2(formularioHojas);
    formularioHojas.llamada.origen = "02";
    this.ponerCia(formularioHojas, "ABANCA GENERALES");
    formularioHojas.mostrarDialogoAbanca();
  }
  static casePrima(formularioHojas: HojasCallCenterComponent){
    formularioHojas.tipoTaller = "";
    this.comboQuien2(formularioHojas);
    formularioHojas.llamada.origen = "02";
    this.ponerCia(formularioHojas, "144625");
    formularioHojas.mostrarDialogo(PrimaComponent);
  }

  static caseRACC(formularioHojas: HojasCallCenterComponent){
    formularioHojas.tipoTaller = "";
    this.comboQuien2(formularioHojas);
    this.ponerCia(formularioHojas, "121342");
  }
  static caseBBVA(formularioHojas: HojasCallCenterComponent){
    formularioHojas.tipoTaller = "";
    //formularioHojas.asegurado.siniestro = "VERIFICADO";
    this.comboQuien2(formularioHojas);
    this.ponerCia(formularioHojas, "CASER(CIA");
  }
  static caseCorredores(formularioHojas: HojasCallCenterComponent){
    formularioHojas.tipoTaller = "";
    this.comboQuien1(formularioHojas);
    formularioHojas.showTrabajos = true;
    //TODO
    // If TxtCampa.Text <> "" Then
    //    BuscarCampa(TxtCampa.Text)
    // End If
  }
  static caseMussap(formularioHojas: HojasCallCenterComponent){
    formularioHojas.tipoTaller = "";
    this.comboQuien2(formularioHojas);
    formularioHojas.showMussap = true;
  }
  static casePelayo(formularioHojas: HojasCallCenterComponent){
    formularioHojas.tipoTaller = "";
    this.comboQuien2(formularioHojas);
    formularioHojas.showPelayo = true;
  }
  /*static caseFraiking(formularioHojas: HojasCallCenterComponent){
    //TODO
    // MsgBox("Todos los servicios de Madrid se deben derivar  al Taller 33 - C/ALCALÁ", MsgBoxStyle.Information, "Atención")
    // poner entidad ("51")
    formularioHojas.tipoTaller = "";
    formularioHojas.asegurado.agente = "116332";
    this.ponerCia(formularioHojas, "MOBILIZE LEASE & CO");
  }*/
  static caseHibu(formularioHojas: HojasCallCenterComponent){
    formularioHojas.tipoTaller = "";
    this.comboQuien3(formularioHojas);
    formularioHojas.showTrabajos = true;
  }
  static caseCentauro(formularioHojas: HojasCallCenterComponent){
    formularioHojas.tipoTaller = "";
    this.comboQuien2(formularioHojas);
    formularioHojas.showObtenerSiniestro = true;
  }
  static caseEnterprise(formularioHojas: HojasCallCenterComponent){
    formularioHojas.tipoTaller = "";
    this.comboQuien2(formularioHojas);
    formularioHojas.enabledSin = true;
  }
  static caseAvis(formularioHojas: HojasCallCenterComponent){
    formularioHojas.tipoTaller = "";
    this.comboQuien2(formularioHojas);
  }
  static caseAlquiber(formularioHojas: HojasCallCenterComponent){
    formularioHojas.tipoTaller = "";
    this.comboQuien2(formularioHojas);
    this.ponerCia(formularioHojas, "ALQUIBER QUALITY");
  }
  static caseWebLaminado(formularioHojas: HojasCallCenterComponent){
    formularioHojas.tipoTaller = "";
    this.comboQuien3(formularioHojas);
    formularioHojas.showTrabajos = true;
    formularioHojas.mensajeObser += " LAMINADO ";
    formularioHojas.trabajoSeleccionado = "0";
    this.ponerCia(formularioHojas, "CONTADOS");
    this.addArticulo(formularioHojas, "67000200", "Lamina Solar Alpha Plus 05 Negra").then(res => {});

  }
  static caseWebElevalunas(formularioHojas: HojasCallCenterComponent){
    formularioHojas.tipoTaller = "";
    this.comboQuien3(formularioHojas);
    formularioHojas.showTrabajos = true;
    formularioHojas.trabajoSeleccionado = "2";
    this.ponerCia(formularioHojas, "CONTADOS");
    this.addArticulo(formularioHojas, "92092000", "ELEVALUNAS VARIOS").then(res => {});
  }
  static caseProyectos(formularioHojas: HojasCallCenterComponent){
    formularioHojas.tipoTaller = "";
    this.comboQuien2(formularioHojas);
    this.ponerCia(formularioHojas, "Proyectos y Seguros");
    formularioHojas.asegurado.agente = "112124";
    this.addArticulo(formularioHojas, "70004190", "NANOTRATAMIENTO ANTILLUVIA 500ML.").then(res => {});
  }
  static caseAdwords(formularioHojas: HojasCallCenterComponent){
    formularioHojas.tipoTaller = "";
    formularioHojas.showObtenerSiniestro = true;
    this.ponerCia(formularioHojas, "JCCM JUNTA");
  }
  static caseMetropolis(formularioHojas: HojasCallCenterComponent){
    formularioHojas.tipoTaller = "";
    formularioHojas.showObtenerSiniestro = true;
    formularioHojas.mostrarArgumentario("Atención!", ["Tienes que abrir el VB el programa MetropolisLunas"], false, true, false);
  }
  static caseCampana(formularioHojas: HojasCallCenterComponent){
    //TODO
    // txtagente.Enabled = True
    // txtagente.ReadOnly = False
  }
  static caseAlphabet(formularioHojas: HojasCallCenterComponent){
    formularioHojas.tipoTaller = "";
    this.comboQuien2(formularioHojas);
    this.ponerCia(formularioHojas, "ALPHABET");
    if (formularioHojas.idAlphabet == ""){
      formularioHojas.mostrarGestionPeticionAlp('alphabet');
    }


  }
  static caseArval(formularioHojas: HojasCallCenterComponent){
    formularioHojas.tipoTaller = "";
    this.comboQuien2(formularioHojas);
    this.textoSiniestro(formularioHojas);
  }
  static caseUrquiabas(formularioHojas: HojasCallCenterComponent){
    formularioHojas.tipoTaller = "";
    this.comboQuien2(formularioHojas);
    formularioHojas.llamada.origen= "03";
    formularioHojas.llamada.tipo= "100";
    formularioHojas.asegurado.agente = "107465";
    this.ponerCia(formularioHojas, "URQUIABAS");
  }
  static caseLeasePlan(formularioHojas: HojasCallCenterComponent){
    //TODO
    formularioHojas.tipoTaller = "";
    formularioHojas.asegurado.agente = "133961";
    this.comboQuien2(formularioHojas);
    formularioHojas.showSiebel = true;
    formularioHojas.showObtenerSiniestro = false;
    this.textoSiniestro(formularioHojas);
    this.ponerCia(formularioHojas, "LEASE PLAN SERVICIOS");
  }
  static caseAllianz(formularioHojas: HojasCallCenterComponent){
    //TODO
    formularioHojas.tipoTaller = "";
    formularioHojas.mensajeObser += " Allianz VIP "
  }
  static caseUNICAL(formularioHojas: HojasCallCenterComponent){
    formularioHojas.tipoTaller = "";
    formularioHojas.llamada.recomendado = "E";
    formularioHojas.llamada.tipo = "100";
    formularioHojas.llamada.origen = "04";
    this.ponerCia(formularioHojas, "UNICAL GRAPHIC");
    this.addArticulo(formularioHojas, "67000200", "Lamina Solar Alpha Plus Negra").then(res => {});
  }
  static caseDrivalia(formularioHojas: HojasCallCenterComponent){
    formularioHojas.tipoTaller = "";
    this.comboQuien2(formularioHojas);
    formularioHojas.llamada.tipo = "100";
    formularioHojas.llamada.origen = "02";
    this.ponerCia(formularioHojas,"DRIVALIA");
  }
  static caseMobilize(formularioHojas: HojasCallCenterComponent){
    formularioHojas.tipoTaller = "";
    this.comboQuien2(formularioHojas);
    formularioHojas.llamada.tipo = "100";
    formularioHojas.llamada.origen = "02";
    this.ponerCia(formularioHojas,"121587");
  }
  static caseElse(formularioHojas: HojasCallCenterComponent){
    formularioHojas.tipoTaller = "";
    formularioHojas.asegurado.agente = "";
    formularioHojas.llamada.recomendado = "";
    formularioHojas.showObtenerSiniestro = false;
    formularioHojas.showSiebel = false;
    formularioHojas.showPelayo = false;
  }
  static ponerCia(formularioHojas: HojasCallCenterComponent, valor: string){
    formularioHojas.tipoTaller = "";
    formularioHojas.auxCia = valor;
  }
  static async addArticulo(formularioHojas: HojasCallCenterComponent, articulo: string, descripcion:string, campa: boolean = false, eurocode: string = "", booking: boolean = false) {

    let art: BusArtCallcenter =
      {
        id: 0,
        eurocode: eurocode,
        ref_ralarsa: articulo,
        oem: "",
        desc: descripcion,
        campa: campa
      }
    let articulo2: ArticuloContact = await BusArtCallcenter.busArt2Articulo(art, formularioHojas.tallerSeleccionado?.delegacion, formularioHojas.token, formularioHojas.articuloService, formularioHojas);
    formularioHojas.agregarArticulo(articulo2, booking);
  }


  static entidadGeneral(formularioHojas: HojasCallCenterComponent, prefix: string){
    formularioHojas.prefixEntidad = prefix;
    formularioHojas.showEntidad= true;
    formularioHojas.entidadList = [];
    formularioHojas.rellenarComboTabla(formularioHojas.entidadList,formularioHojas.prefixEntidad, ["codi", "descripcio"]);
  }
  static entidadCaser(formularioHojas: HojasCallCenterComponent){
    if(formularioHojas.llamada.entrada.includes("100000012") || formularioHojas.llamada.entrada.includes("100000019")){
      formularioHojas.prefixEntidad = "EB";
      formularioHojas.showEntidad = true;
      formularioHojas.entidadList = [];
      formularioHojas.rellenarComboTabla(formularioHojas.entidadList,formularioHojas.prefixEntidad, ["codi", "descripcio"]);
    }
  }

  static entidadAxa(formularioHojas: HojasCallCenterComponent){
    formularioHojas.showObtenerSiniestro = formularioHojas.llamada.entrada.includes("100000030");
  }
  static entidadArval(formularioHojas: HojasCallCenterComponent){
    formularioHojas.showObtenerSiniestro = formularioHojas.llamada.entrada.includes("100000095");
  }

  static entidadAllianz(formularioHojas: HojasCallCenterComponent){
    if (formularioHojas.llamada.entrada.includes("100000094") && formularioHojas.asegurado.siniestro != ""){
      const totalCaracteres = formularioHojas.asegurado.siniestro.length;
      const dosPrimerosCaracteres = formularioHojas.asegurado.siniestro.trim().substring(0, 2);
      const restoDeCaracteres = formularioHojas.asegurado.siniestro.trim().substring(2, totalCaracteres);
      if (dosPrimerosCaracteres.toLowerCase() === "ds") {
        if (restoDeCaracteres.length === 9) {
          if (!isNaN(+restoDeCaracteres)) {
            if (!restoDeCaracteres.trim().startsWith("4")) {
              formularioHojas.mostrarArgumentario("Error", ["El número de la póliza és incorrecto... Después de las letras DS el número de póliza debe tener un número 4 al inicio"]);
            }
          } else {
            formularioHojas.mostrarArgumentario("Error", ["El número de la póliza és incorrecto... Después de las letras DS los siguientes caracteres deben ser números"]);
          }
        } else {
          formularioHojas.mostrarArgumentario("Error",["El número de la póliza está incompleto... Faltan caracteres, en total deben ser 11 incluidas las letras DS"]);
        }
      } else {
        formularioHojas.mostrarArgumentario("Error",["El número de la póliza debe empezar con las letras DS"]);
      }
    }
  }
  static entidadElse(formularioHojas: HojasCallCenterComponent){
    formularioHojas.enabledSin = false;
    formularioHojas.showEntidad = false;
    formularioHojas.showObtenerSiniestro = false;
  }
}
